import AxiosService from './AxiosService';

// Short-lived API keys (KZN-18871) for the AI block panel's pi-poc session

// Seconds
export const TEMPORARY_API_KEY_TTL = 1200;

export interface TemporaryApiKey {
  apiKey: string;
  userId: string;
  businessId: string;
  expires: string;
}

interface TemporaryApiKeyResponse {
  api_key: string;
  user_id: string;
  business_id: string;
  expires: string;
}

const createTemporaryApiKey = async (
  ttl: number = TEMPORARY_API_KEY_TTL
): Promise<TemporaryApiKey> => {
  const { data } = await AxiosService.post<TemporaryApiKeyResponse>(
    '/api-key/temporary',
    { ttl }
  );
  return {
    apiKey: data.api_key,
    userId: data.user_id,
    businessId: data.business_id,
    expires: data.expires,
  };
};

const TemporaryApiKeyService = Object.freeze({ createTemporaryApiKey });

export default TemporaryApiKeyService;
